module.exports = "/_next/static/images/kzami_top-a17041a4ff563c26e0241dfacedaaa12.jpg";